export default (key) =>
  `&#8202;<span class="mceNonEditable" data-case-detail="${key}">{$${key}}</span>&#8202;`
